<template>
    <!--我的收藏-->
    <div class="collection">
        <ul class='main_title'>
            <li v-for="(item,index) in nav" :class="{active:collect.object_type === item.value }" @click="
                    changeTab(item)" :key="index">
                <span v-text="item.value"></span>
            </li>
        </ul>
        <div class="info" id='info'>
            <!--我的收藏 新房-->
            <div class="collect_new" v-if="collect.object_type === '新房'">
                <ul>
                    <li class="item" v-for="(item,index) in newLists" :key="index">
                        <div class="itemchild"
                             @click="$router.push({path:'/newDetails/'+ item.object_id})">
                            <div class="images"><img :src="item.缩略图" :onerror="imgerrorfun"></div>
                            <div class="center">
                                <div class="title">{{item.楼盘名称}}</div>
                                <div class="detail">
                                    <i class="iconfont">&#xe603;</i>
                                    <ul>
                                        <li>{{ item.huxing}}</li>
                                        <li>{{ item.面积 }}平米</li>
                                        <li>{{ item.装修情况 }}</li>
                                        <li>{{ item.交易状态}}</li>
                                    </ul>
                                </div>
                                <div class="address">
                                    <i class="iconfont">&#xe669;</i>
                                    <div>地址：
                                        <span>{{ item.详细地址 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right"><span>{{ item.均价 }}</span>元/平米</div>
                        </div>
                        <span class="delete" @click="del(item)">删除</span>
                    </li>
                </ul>
                <el-pagination
                        layout="prev, pager, next"
                        :current-page.sync="collect.page"
                        :page-size='collect.limit'
                        @current-change="handleCurrentChange"
                        :total="totalNum">
                </el-pagination>
            </div>
            <!--我的收藏 二手房-->
            <div class="collect_two" v-if="collect.object_type === '二手房'">
                <ul>
                    <li class="item" v-for="item in secondList" :key="">
                        <div class="itemchild"
                             @click="$router.push({path:'/secondDetails/' + item.object_id})">
                            <div class="images"><img :src="item.缩略图" alt="" :onerror="imgerrorfun"></div>

                            <div class="center">
                                <div class="title">{{ item.名称 }}</div>
                                <div class="detail">
                                    <i class="iconfont">&#xe603;</i>
                                    <ul>
                                        <!--<li>{{ item.室}}室{{ item.厅}}厅{{ item.厨}}厨{{ item.卫}}卫</li>-->
                                        <li>{{ item.面积 }}平米</li>
                                        <li>{{ item.户型 }}</li>
                                        <li>{{ item.楼层层数 }}</li>
                                        <li>{{ item.建房时间 }}年建</li>
                                    </ul>
                                </div>
                                <div class="address">
                                    <i class="iconfont">&#xe669;</i>
                                    <div>地址：
                                        <span>{{ item.详细地址}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right"><span>{{ item.总价 }}</span>万元</div>
                        </div>
                        <span class="delete" @click="del(item)">删除</span>
                    </li>
                </ul>
                <el-pagination
                        layout="prev, pager, next"
                        :current-page.sync="collect.page"
                        :page-size='collect.limit'
                        @current-change="handleCurrentChange"
                        :total="totalNum">
                </el-pagination>
            </div>
            <!--我的收藏 租房-->
            <div class="collect_rent" v-if="collect.object_type === '租房' ">
                <ul>
                    <li class="item" v-for="item in rentList" :key="">
                        <div class="itemchild"
                             @click="$router.push({path:'/rentDetails/' + item.object_id})">
                            <div class="images"><img :src="item.缩略图" alt="" :onerror="imgerrorfun"></div>
                            <div class="center">
                                <div class="title">{{ item.名称 }}</div>
                                <div class="detail">
                                    <i class="iconfont">&#xe603;</i>
                                    <ul>
                                        <li>{{ item.室}}室{{ item.厅}}厅{{ item.厨}}厨{{ item.卫}}卫</li>
                                        <li>{{ item.面积 }}平米</li>
                                        <li>{{ item.装修 }}</li>
                                        <li>{{ item.类型}}</li>
                                        <li>{{ item.建房时间}}年建</li>
                                    </ul>
                                </div>
                                <div class="address">
                                    <i class="iconfont">&#xe669;</i>
                                    <div>地址：
                                        <span>{{ item.详细地址 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right"><span>{{ item.价格 }}</span>元/月</div>
                        </div>
                        <span class="delete" @click="del(item)">删除</span>
                    </li>
                </ul>
                <el-pagination
                        layout="prev, pager, next"
                        :current-page.sync="collect.page"
                        :page-size='collect.limit'
                        @current-change="handleCurrentChange"
                        :total="totalNum">
                </el-pagination>
            </div>
            <el-dialog
                    title="确认删除?"
                    :visible.sync="dialogVisible"
                    width="30%"
                    center>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="comfirmDel()">确 定</el-button>
                  </span>
            </el-dialog>
            <!--删除确认结束-->
        </div>
        <!--<div @click="backTop()" class="back" v-show="upload" :title="toTop">-->
        <!--<i class="el-icon-caret-top"></i>-->
        <!--</div>-->
    </div>
</template>

<script type="text/ecmascript-6">
	import {
		delCollectHouse,
		getCollectHouseList
	} from '../../api/index'

	export default {
		data() {
			return {
				nav: [{value: '新房'}, {value: '二手房'}, {value: '租房'}],
				newLists: [],//新房列表
				secondList: [],//二手房列表
				//返回图片为空时默认图片
				imgerrorfun: '',
				// imgerrorfun: 'this.src="' + require('../assets/new-details/img_xfxiangqing_banner.png') + '"',
				rentList: [],//租房列表
				// limit: 5,//每页显示数目
				// page: 1,  //当前页码
				totalNum: 0,
				type: 1,//判断房租类型
				dialogVisible: false,
				id: '',
				upload: false,
				toTop: '返回顶部',
				collect: {
					page: 1,
					limit: 10,
					object_type: '新房',
					token: ''
				}
			};
		},
		components: {},
		created() {

		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.collect.token = localStorage.getItem('token');
			this.init();
		},
		methods: {
			//删除
			del(item) {
				this.dialogVisible = true
				this.id = item.id
				// console.log(item)
			},
			//确认删除
			comfirmDel() {
				// console.log(this.id)
				delCollectHouse({
					object_id: this.object_id,
					token: this.collect.token
				}).then(res => {
					// console.log(res)
					this.getCollHouse()
					this.dialogVisible = false
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			//默认显示新房
			init() {
				let _this = this
				getCollectHouseList(
					this.collect
				).then(res => {
					// console.log(res)
					if (res.code === 0) {
						_this.newLists = res.data;
						_this.totalNum = res.count
					} else if (res.code === -101) {
						this.$message({
							message: '未登录',
							type: 'warning',
							duration: 1500
						})
						this.$router.push({name: 'login'})
					}

				}).catch(err => {
					// console.log(err)
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			//点击改变选项
			changeTab(item) {
				// console.log(item)
				this.collect.object_type = item.value;
				this.getCollHouse()
			},
			//选项改变时改变显示
			getCollHouse() {
				let _this = this;
				_this.collect.page = 1
				getCollectHouseList(
					this.collect
				).then(res => {
					console.log(res.data)
					if (this.collect.object_type === '新房') {
						_this.newLists = res.data;
					}
					if (this.collect.object_type === '二手房') {
						_this.secondList = res.data;
					}
					if (this.collect.object_type === '租房') {
						_this.rentList = res.data;
					}
					_this.totalNum = res.count
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			// 分页
			handleCurrentChange(val) {
				// console.log(val)
				let _this = this
				_this.collect.page = val
				// let pms = {
				// 	limit: _this.limit
				// }
				// if (val >= 1) {
				// 	Object.assign(pms, {page: val})
				// }
				getCollectHouseList(
					this.collect
				).then(res => {
					// console.log(res)
					if (this.collect.object_type === '新房') {
						_this.newLists = res.data;
					}
					if (this.collect.object_type === '二手房') {
						_this.secondList = res.data;
					}
					if (this.collect.object_type === '租房') {
						_this.rentList = res.data;
					}
					_this.totalNum = res.count
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			},
			// //返回顶部
			// backTop() {
			// 	document.body.scrollTop = 0
			// 	document.documentElement.scrollTop = 0
			// },
			// handleScroll() {
			// 	let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 	// console.log(scrollTop)
			// 	if (scrollTop > 100) {
			// 		this.upload = true
			// 	} else {
			// 		this.upload = false
			// 	}
			// },
		},
		destroyed() {
			// window.removeEventListener('scroll', this.handleScroll)
		}
	};
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .collection {
        .main_title {
            display: flex;
            align-items: center;
            width: 100%;
            border-bottom: 1px solid #E6E6E6;
            li {
                width: 107px;
                text-align: center;
                font-size: 16px;
                color: #4d4d4d;
                margin-left: 37px;
                line-height: 40px;
                border-bottom: 2px solid transparent;
                cursor: pointer
            }
            li:first-child {
                margin-left: 0;
            }
            li.active {
                color: #FF5E5E;
                border-bottom: 2px solid #FF5E5E;
            }
        }
        .info {
            width: 820px;
            overflow: hidden;
            .collect_new, .collect_two, .collect_rent {
                width: 837px;
                max-height: 600px;
                overflow-y: scroll;
                /*margin-bottom: 60px;*/
                ul {
                    margin-bottom: 30px;
                    li.item {
                        position: relative;
                        padding: 40px 0;
                        border-bottom: 1px solid #F0F0F0;
                        cursor: pointer;
                        .itemchild {
                            height: 160px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .images {
                                width: 280px;
                                height: 160px;
                                img {
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .center {
                                flex: 1;
                                height: 100%;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                margin: 0 10px 0 40px;
                                .title {
                                    font-size: 24px;
                                    font-family: MicrosoftYaHei-Bold;
                                    font-weight: bold;
                                    color: #333;
                                }
                                div {
                                    display: flex;
                                    align-items: center;
                                    i {
                                        margin-right: 10px;
                                    }
                                }
                                .detail {
                                    font-size: 14px;
                                    display: flex;
                                    align-items: flex-start;
                                    justify-content: space-between;
                                    margin-top: 30px;
                                    ul {
                                        flex: 1;
                                        display: flex;
                                        justify-content: space-between;
                                        li {
                                            font-size: 14px;
                                            /*margin-left: 30px;*/
                                        }
                                        li:first-child {
                                            margin-left: 0;
                                        }
                                    }
                                }
                            }
                            .right {
                                /*width: 100px;*/
                                flex-shrink: 0;
                                font-size: 14px;
                                color: #FF5E5E;
                                text-align: right;
                                span {
                                    font-size: 24px;
                                    margin-right: 10px;
                                }
                            }
                        }
                        .delete {
                            position: absolute;
                            top: 40px;
                            right: 0;
                            font-size: 14px;
                            color: #666;
                            z-index: 2;
                        }
                    }
                }
            }
        }

        /*.back {*/
        /*height: 40px;*/
        /*width: 40px;*/
        /*position: fixed;*/
        /*right: 50px;*/
        /*bottom: 100px;*/
        /*display: block;*/
        /*color: #fff;*/
        /*font-size: 25px;*/
        /*border-radius: 50%;*/
        /*background-color: #e6e6e6;*/
        /*text-align: center;*/
        /*line-height: 40px;*/
        /*cursor: pointer;*/
        /*}*/
    }
</style>